import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createProductConfig,
  deleteProductConfig,
  getAllProductConfigs,
  updateProductConfig,
} from "controller";
import { ApiErrorType, GetQueryProps } from "shared";
import { sentryLogger } from "utilz";

export const useGetAllProductConfigs = ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
}: GetQueryProps) => {
  return useQuery({
    queryKey: [
      "productConfigs",
      sortColumn,
      sortDirection,
      perPageCount,
      pageNumber,
      filter,
      searchQuery,
    ],
    queryFn: () =>
      getAllProductConfigs({
        perPageCount,
        pageNumber,
        sortColumn,
        sortDirection,
        filter,
        searchQuery,
      }),
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getAllProductConfigs",
      });
    },
  });
};

export const useCreateProductConfig = () => {
  const queryClient = useQueryClient();
  //   return useMutation(createProductConfig, {
  return useMutation({
    mutationFn: (data: any) => createProductConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["productConfigs"] });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "createProductConfig",
      });
    },
  });
};

export const useDeleteProductConfig = () => {
  const queryClient = useQueryClient();
  //   return useMutation(deleteProductConfig, {
  return useMutation({
    mutationFn: (data: { product_ids: string[] }) => deleteProductConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["productConfigs"] });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "deleteProductConfig",
      });
    },
  });
};

export const useUpdateProductConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => updateProductConfig(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["productConfigs"] });
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "updateProductConfig",
      });
    },
  });
};
